export default "__VITE_ASSET__DyupBLNH__"